import { render, staticRenderFns } from "./tableTodayNew.vue?vue&type=template&id=1a5fe7a6&scoped=true"
import script from "./tableTodayNew.vue?vue&type=script&lang=js"
export * from "./tableTodayNew.vue?vue&type=script&lang=js"
import style0 from "./tableTodayNew.vue?vue&type=style&index=0&id=1a5fe7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5fe7a6",
  null
  
)

export default component.exports